import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { FinancialDocumentStatusChangeToBookedModel } from '@saliente/common-documents';

@Component({
    selector: 'expert-book-document-with-zero',
    templateUrl: 'book-document-with-zero.component.html',
    standalone: false
})
export class ExpertBookDocumentWithZeroComponent implements OnInit {
	@Input() public model: FinancialDocumentStatusChangeToBookedModel;

	@Output() public save = new EventEmitter();
	@Output() public close = new EventEmitter();

	constructor() { }

	public ngOnInit() { }

	public onBookWithZeroHelp() {
		const url = "https://app.keez.ro/help/expert/platforma/documente/documente_actiuni.html"
		window.open(url, '_blank', 'noopener noreferrer');
	}

	public validateComment(value: string) {
		if (value && (value.length < 20)) {
			return "Comentariul trebuie să aibă minim 20 de caractere!";
		}

		return true;
	}
}
